"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _styledComponents = require("styled-components"); // Copyright © VNG Realisatie 2020
// Licensed under the EUPL
//


var getSvg = function getSvg(fillColor) {
  return "<svg xmlns=\"http://www.w3.org/2000/svg\" view-box=\"0 0 24 24\" width=\"24\" height=\"24\"><path fill=\"".concat(fillColor, "\" d=\"M12 22C6.477 22 2 17.523 2 12S6.477 2 12 2s10 4.477 10 10-4.477 10-10 10zm-1-7v2h2v-2h-2zm0-8v6h2V7h-2z\"/></svg>");
};

var style = function style(p) {
  return (0, _styledComponents.css)(["background-color:", ";background-image:url(data:image/svg+xml;base64,", ");border-left-color:", ";"], p.theme.colorAlertErrorBackground, btoa(getSvg(p.theme.colorAlertError)), p.theme.colorAlertError);
};

var _default = style;
exports["default"] = _default;